/**
 * The Structured Capital priority tiers (1 = most urgent). Single source for the table's key strip,
 * the Priority header ⓘ legend and the Sonar record modal's priority hint.
 */
export interface StructCapPriorityTier {
  value: number;
  label: string;
}

export const STRUCT_CAP_PRIORITY_TIERS: ReadonlyArray<StructCapPriorityTier> = [
  { value: 1, label: 'High priority / high time spend' },
  { value: 2, label: 'High priority / low time spend' },
  { value: 3, label: 'New deal / determine time spend' },
  { value: 4, label: 'Low priority / medium time spend' },
  { value: 5, label: 'Low priority / low time spend' },
  { value: 6, label: 'Passing' },
  { value: 7, label: 'Non-SC deals' }
];
